var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{staticClass:"note-pane-quill-instance",attrs:{"options":_vm.quillConfiguration,"disabled":_vm.isBusy},on:{"input":function($event){return _vm.$emit('input', _vm.content)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }